import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPageTitle } from 'actions/header';
import { translate } from '@haldor/ui';
import MyPlanning from '../Overview/Sections/MyPlans';
var AllPlans = /*#__PURE__*/function (_Component) {
  function AllPlans() {
    var _this;
    _classCallCheck(this, AllPlans);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AllPlans, [].concat(args));
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('Plans'));
    });
    return _this;
  }
  _inherits(AllPlans, _Component);
  return _createClass(AllPlans, [{
    key: "render",
    value: function render() {
      if (this.props.students == null) {
        return null;
      }
      return /*#__PURE__*/React.createElement(MyPlanning, {
        dateRestriction: false
      });
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    students: state.guardians.students,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle
})(AllPlans);